import { getCookieByName } from '../utils/functions';

export const useAutomaticDiscountBadge = () => {
  const enableAutomaticBadgeCookie = getCookieByName(
    'automaticDiscountBadge',
    true
  );
  const enableAutomaticBadgeFlow =
    window.rxcBrain?.flowDefiningAttributes?.automaticDiscountBadge;

  if (
    enableAutomaticBadgeCookie !== null &&
    enableAutomaticBadgeCookie !== undefined
  ) {
    return enableAutomaticBadgeCookie as boolean;
  }

  if (
    enableAutomaticBadgeFlow !== null &&
    enableAutomaticBadgeFlow !== undefined
  ) {
    return enableAutomaticBadgeFlow as boolean;
  }

  return false;
};
